
import { DomainService } from './DomainService';
const baseUrl = DomainService.GetBaseUrl() + "EventCreadential/";

const EventCreadential = async (formData) => {

    try {
        const res = await fetch(baseUrl + "CreateEventLogin", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        });
        const data = await res.json();
        return data;
    } catch (error) {
    }
}
const EventLogin = async (loginId, password,passwordType) => {
    const formdata={
        UserName:loginId,
        Password:password,
        PasswordType:passwordType,
        UsertypeId:1
      }
    try {
        const res = await fetch(baseUrl + "EventLogin", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formdata)
        });
        const data = await res.json();
        return data;
    } catch (error) {
    }
}

export const EventCredentialsSevice = {
    EventCreadential,
    EventLogin
};